// extracted by mini-css-extract-plugin
export default {"iconsContainerOuter":"cimp70dxs","iconContainer":"ce83k04jc","icon":"cc4liwxoe","container":"cbxfp6ie9"};